import {Updatable} from '@gongxigames/framework/core/fragments/update/Updatable';

export class HTMLMovieClip extends Updatable {
    private readonly _frames: HTMLImageElement[];
    private readonly _frameDuration: number;
    private readonly _lastFrameDuration: number;
    private _currentTime = 0;
    private _currentFrame = 0;
    private _container: HTMLElement;

    constructor(element: HTMLImageElement, imageUrls: string[], fps = 5, lastFrameDuration = 2000) {
        super();

        this._container = element.parentElement!;

        // TODO: refactoring in new major version
        if (!this._container) {
            throw new Error('not implemented!');
        }
        element.parentElement!.removeChild(element);

        this._frames = imageUrls.map( src => {
            const img = document.createElement('img');

            img.src = src;

            return img;
        });
        this._frameDuration = 1000 / fps;
        this._lastFrameDuration = lastFrameDuration;

        this._container.appendChild(this._frames[this._currentFrame]);
    }

    public update(dt: number): void {
        this._currentTime += dt;

        const totalTime = this._frames.length * this._frameDuration + this._lastFrameDuration;

        if (this._currentTime >= totalTime) {
            this._currentTime %= totalTime;
        }

        let frame = Math.floor(this._currentTime / this._frameDuration);

        if (frame >= this._frames.length) {
            frame = this._frames.length - 1;
        }

        if (this._currentFrame !== frame) {
            this._container.removeChild(this._frames[this._currentFrame]);
            this._container.appendChild(this._frames[frame]);
            this._currentFrame = frame;
        }
    }
}
